// CB:BEGIN postauth-helper-v2
// Enhanced post-auth redirect management with lock functionality
export const POST_AUTH_KEY = "postAuth:redirect";
export const REDIRECT_LOCK_KEY = "redirect:lock";

export const setPostAuthRedirect = (path: string) => {
  sessionStorage.setItem(POST_AUTH_KEY, path);
};

export const consumePostAuthRedirect = (): string | null => {
  const val = sessionStorage.getItem(POST_AUTH_KEY);
  if (val) sessionStorage.removeItem(POST_AUTH_KEY);
  return val;
};

// Read without removing
export const peekPostAuthRedirect = (): string | null =>
  sessionStorage.getItem(POST_AUTH_KEY);

export const setRedirectLock = () => sessionStorage.setItem(REDIRECT_LOCK_KEY, "1");
export const clearRedirectLock = () => sessionStorage.removeItem(REDIRECT_LOCK_KEY);
export const hasRedirectLock = () => sessionStorage.getItem(REDIRECT_LOCK_KEY) === "1";

// Pages we consider "onboarding / next steps"
export const ONBOARDING_PATHS = new Set([
  "/next-steps",
  "/measurement",
  "/roof-report-coming-soon",
]);
export const isOnboardingPath = (p: string) => ONBOARDING_PATHS.has(p);

// Remove Clerk params so they don't re-fire a redirect
export const clearClerkRedirectParams = () => {
  const url = new URL(window.location.href);
  const keys = ["__clerk_redirect_url", "__clerk_status", "redirect_url", "__clerk_added"];
  let changed = false;
  for (const k of keys) {
    if (url.searchParams.has(k)) {
      url.searchParams.delete(k);
      changed = true;
    }
  }
  if (changed) window.history.replaceState({}, "", url.toString());
};
// CB:END postauth-helper-v2
